<template>
  <div class="test-environment-page">
    <h1>Test Environment</h1>

    <p v-if="message">{{message}}</p>
    <button @click="start_test" v-if="!test_started">Start Test</button>
    <div v-if="test_started" class="test">
      <!-- Question Ledger -->
      <div class="ledger">
        <p v-for="(question, index) in questions" :key="index">
          <span :class="{ flagged: flaggedQuestions.includes(index) }">Question {{ index + 1 }}</span> |
        </p>
      </div>

      <!-- Timer -->
      <div class="timer">
        <p>Time: {{ timeRemaining }} seconds</p>
      </div>

      <!-- Question Display Area -->
      <div class="question-display">
        <p v-if="currentQuestion">{{ currentQuestion.question }}</p>
        <ul>
          <li v-for="(option, index) in currentQuestion?.options" :key="index">
            <label>
              <input
                type="radio"
                :value="index"
                v-model="userAnswers[currentIndex]"
                @change="selectAnswer(index)"
              />
              {{ option }}
            </label>
          </li>
        </ul>
      </div>

      <!-- Navigation Buttons -->
      <div class="navigation">
        <button @click="previous" :disabled="currentIndex === 0">Previous</button>
        <button @click="next" :disabled="currentIndex === questions.length - 1">Next</button>
        <button @click="flag">Flag Question</button>
        <button v-if="query.test_type === 'practice'" @click="checkAnswer">Check Answer</button>
        <button @click="completeTest">Finish Test</button>
      </div>

      <!-- Results Display -->
      <div class="results" v-if="testCompleted">
        <h2>Test Completed</h2>
        <p>Your results will be displayed here.</p>
      </div>
    </div>
  </div>
</template>

<script>
import { useRoute } from 'vue-router';
import { getQuestions  } from '@/services/testService';
export default {
  name: 'TestEnvironment',
  data() {
    return {
      isPractice: true,
      query: null,
      questions: [],
      ques_data: [],
      message: null,
      test_started: false,
      currentIndex: 0, // Tracks the current question index
      flaggedQuestions: [], // Stores flagged questions
      timeRemaining: 600, // Example: 10 minutes (600 seconds)
      timer: null,
      testCompleted: false, // Marks when the test is finished
      userAnswers: {},
    };
  },
  computed: {
    currentQuestion() {
      return this.questions.length > 0 ? this.questions[this.currentIndex] : null;
    },
  },
  methods: {
    async get_questions(subscription_id, user_id, attemptNumber){
      let res = await getQuestions(subscription_id, user_id, attemptNumber);
      if(res.data?.message == 'Invalid attempt number'){
        this.$router.push('/dashboard/user/home')
      }else{
        this.questions = res.data.questions;
      }
    },

    // ✅ Start the test and initialize timer
    start_test() {
      if (this.questions.length === 0) {
        console.log("No questions available.");
        return;
      }
      this.test_started = true;
      this.startTimer();
    },

    // ✅ Start countdown timer
    startTimer() {
      this.timer = setInterval(() => {
        if (this.timeRemaining > 0) {
          this.timeRemaining--;
        } else {
          this.completeTest();
        }
      }, 1000);
    },

    // ✅ Move to the next question
    next() {
      if (this.currentIndex < this.questions.length - 1) {
        this.currentIndex++;
      }
    },

    // ✅ Move to the previous question
    previous() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      }
    },

    // ✅ Flag a question for review
    flag() {
      if (!this.flaggedQuestions.includes(this.currentIndex)) {
        this.flaggedQuestions.push(this.currentIndex);
      }
    },

    // ✅ Check Answer (for practice mode)
    checkAnswer() {
      if (this.query.test_type !== "practice") return;

      const currentQ = this.currentQuestion;
      if (!currentQ) return;

      const userAnswer = this.userAnswers[this.currentIndex];

      if (userAnswer === undefined) {
        console.log("Please select an answer first.");
        return;
      }

      if (userAnswer === currentQ.correctAnswer) {
        console.log("Correct Answer!");
      } else {
        console.log("Wrong Answer!");
      }
    },

    // ✅ Select an answer
    selectAnswer(optionIndex) {
      this.userAnswers[this.currentIndex] = optionIndex;
    },

    // ✅ Complete the test
    completeTest() {
      clearInterval(this.timer);
      this.testCompleted = true;
    },
  },
  mounted() {

    const route = useRoute();
    this.query = route.params;
    this.get_questions(this.query.subscription_id, this.query.user_id, this.query.attemptNumber);
    
  },
};
</script>

<style scoped>
.ledger {
  background: #f3f3f3;
  padding: 10px;
  margin-bottom: 10px;
}
.flagged {
  color: red;
  font-weight: bold;
}
.timer {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}
.question-display {
  background: #fff;
  padding: 10px;
  border: 1px solid #ddd;
}
.navigation {
  margin-top: 10px;
}
.results {
  margin-top: 20px;
  font-size: 18px;
  font-weight: bold;
}
</style>
